import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
import api from "./api.js";
export default function resheduleApi(order_id,reason){
const Authorization='bearer '+localStorage.getItem('token');
  const rider_id=localStorage.getItem('rider_id');
  fetch(`${API_URL}rest/V1/rider/rescheduleOrder`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
      body:JSON.stringify({ jobOrderId:order_id,
        reason:reason})
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
          window.location.reload();
            return response.json();
        })
        .then(function(data) {
            // api.callShippingJobs(component,trip_id);
    })
}



// WEBPACK FOOTER //
// ./src/utility/api/resheduleApi.js